import {useParams} from 'react-router'
import {dialogApi} from '../../../../api/dialogApi'
import {LoadingPage} from '../../../LoadingPage'
import {SummaryCard} from './SummaryCard/SummaryCard'
import {KeyMetricsCard} from './KeyMetricsCard/KeyMetricsCard'
import {SentimentCard} from './SentimentCard/SentimentCard'
import {TrendingTopicsCard} from './TrendingTopicsCard/TrendingTopicsCard'
import {ResponsesCard} from './ResponsesCard/ResponsesCard'
import {MIN_RESPONSES_FOR_AI_ANALYSIS} from '../../../../constants/dialogConstants'
import styles from './DialogAnalytics.module.scss'

export const DialogAnalytics: React.FC = () => {
  const {dialogId} = useParams<{dialogId: string}>()
  const {data: dialogDetails} = dialogApi.useDialogDetails(dialogId ?? '')
  const questionText = dialogDetails?.questionText ?? ''
  const totalResponsesCount = dialogDetails?.totalResponsesCount || 0

  const hasMinimumResponses =
    totalResponsesCount >= MIN_RESPONSES_FOR_AI_ANALYSIS

  const {isLoading} = dialogApi.useDialogAnalytics(
    dialogId ?? '',
    hasMinimumResponses,
  )

  return (
    <div className={styles.dialogAnalytics}>
      {isLoading && <LoadingPage />}
      <div className={styles.question}>{questionText}</div>

      {!isLoading && hasMinimumResponses && (
        <>
          <SummaryCard />
          <div className={styles.block}>
            <KeyMetricsCard />
            <SentimentCard />
          </div>
          <div className={styles.block2}>
            <div>
              <TrendingTopicsCard />
            </div>
            <ResponsesCard />
          </div>
        </>
      )}
      {!isLoading && !hasMinimumResponses && (
        <>
          <KeyMetricsCard />
          <ResponsesCard />
        </>
      )}
    </div>
  )
}
